import { Helmet } from "react-helmet";
import React, { Component } from "react";
import "../../styles/devices/devices.scss";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import { Button } from "react-bootstrap";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocal } from "../../utils/dateConvert";

class DeleteZone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      depotDetails: [],
    };
  }
  async componentDidMount() {
    let depotId = this.props.match.params.id;
    this.props.setLoadingPageAction(true);

    try {
      let depotDetails = await axios.get(
        `${apiHost}/api/POI/SelectPOI/${depotId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("depotDetails", depotDetails);
      this.setState({ depotDetails: depotDetails.data });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  }
  // http://localhost:5000/api/Depots/DeleteDepot/08d7c00a-3db0-483c-8f94-aeb974bf8fbf
  deleteDepot = async () => {
    this.props.setLoadingPageAction(true);
    let Id = this.props.match.params.id;
    try {
      await axios.get(`${apiHost}/api/POI/DeletePOI/${Id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      //   console.log("eventDetails id", eventDetails.data);
      this.props.setLoadingPageAction(false);

      // this.props.history.push("/zones");
      this.props.history.goBack();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  render() {
    const { depotDetails } = this.state;

    return (
      <React.Fragment>
        <Layout>
          <Helmet>
            <title>Point Of Interest Details </title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <h2>Details </h2>
              <h1 style={{ fontSize: "24px" }}>
                Are you sure you want delete this?
              </h1>

              <h6>Zone</h6>
              <hr />
              <div className="depotDetails">
                <div className="individualDetail">
                  <p className="left"> Customer</p>
                  <p className="right">{depotDetails.customerName}</p>
                </div>

                <div className="individualDetail">
                  <p className="left"> Name</p>
                  <p className="right">{depotDetails.name} </p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Description</p>
                  <p className="right">{depotDetails.description} </p>
                </div>
                <div className="individualDetail">
                  <p className="left">MapOverlay</p>
                  <p className="right">{depotDetails.overlay}</p>
                </div>

                <div className="individualDetail">
                  <p className="left">DefaultDuration</p>
                  <p className="right">{depotDetails.duration}</p>
                </div>
                <div className="individualDetail">
                  <p className="left">Address</p>
                  <p className="right">{depotDetails.address}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Status</p>
                  <p className="right">
                    {" "}
                    {depotDetails.status == 1 ? "Active" : "Disabled"}{" "}
                  </p>
                </div>
                <div className="individualDetail">
                  <p className="left">Created</p>
                  <p className="right">{utcToLocal(depotDetails.dbCreated)}</p>
                </div>
                <div className="individualDetail">
                  <p className="left"> Updated</p>
                  <p className="right">{utcToLocal(depotDetails.dbUpdated)}</p>
                </div>
              </div>
              <br />
              <div className="footer-menu">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    // this.props.history.push("/zones");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                &nbsp;
                <Button size="sm" variant="primary" onClick={this.deleteDepot}>
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteZone);
